module.exports = __webpack_public_path__ + "img/level1_mining_hands_mask.8303ca52.png";